module.exports = __webpack_public_path__ + "static/img/Adam_Treloar_desktop.a48af10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam_Treloar_desktop.jpg
// module id = sEk8
// module chunks = 0